import {
  Box,
  CircularProgress,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as LeftArrowIcon } from "../../../../assets/svg/LeftArrowIcon.svg";
import { milestoneStatusStyleArray, statusStyleArray } from "../../config";
import { formattedAmount } from "../../../../utils/CommonFunction";
import moment from "moment";
import BudgetCarousel from "./BudgetCarousel";
import { useTheme } from "@emotion/react";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

function MilestoneDetails() {
  const { id, milestoneId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const {
    milestoneDetails,
    project,
    styles: passedStyles,
  } = location.state || {};
  const [loader, setLoader] = useState(true);
  const styles = passedStyles || {}; // fallback in case it's not passed

  console.log("Milestone Details:", milestoneDetails);
  console.log("Project Details:", project);

  useEffect(() => {
    if (milestoneDetails && project) {
      setLoader(false);
    }
  }, [milestoneDetails, project]);

  return loader ? (
    <center style={passedStyles.header}>
      <CircularProgress />
    </center>
  ) : (
    <>
      <div style={passedStyles.container}>
        <header style={passedStyles.header}>
          <div style={passedStyles.headerContent}>
            <LeftArrowIcon
              onClick={() => navigate(-1)}
              style={{ cursor: "pointer" }}
            />
            <div
              style={{
                ...passedStyles.idText,
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              {project?.name}
            </div>
          </div>
        </header>

        <div style={passedStyles.subContainer}>
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: isMobile && "20px",
            }}
          >
            <div style={{ ...passedStyles.rowFlex, gap: "15px", flex: "1" }}>
              <Box
                component="img"
                src={
                  milestoneDetails?.milestone_image
                    ? milestoneDetails?.milestone_image?.path
                    : "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                }
                alt="Project Icon"
                sx={{
                  width: 90,
                  height: 90,
                  borderRadius: "16px",
                  marginRight: 1,
                }}
              />
              <div style={passedStyles.columnFlex}>
                <h2 style={passedStyles.projectHeading}>
                  {milestoneDetails?.milestone_name}
                </h2>
                <p style={passedStyles.endDate}>
                  Last Update:{" "}
                  {milestoneDetails?.updatedAt
                    ? moment(milestoneDetails.updatedAt).format(
                        "MMM DD, YYYY hh:mm A"
                      )
                    : "N/A"}
                </p>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Box
                    style={{
                      width: "15px",
                      height: "15px",
                      borderRadius: "50%",
                      backgroundColor:
                        milestoneStatusStyleArray.find(
                          (style) => style.status === milestoneDetails?.status
                        )?.backgroundColor || "transparent",
                      border: "3px solid #e5e5e5",
                    }}
                  />
                  <Typography
                    style={{
                      fontSize: "14px",
                      marginLeft: "8px",
                      color: "#0D0D0E",
                    }}
                  >
                    {getStatusDisplayText(milestoneDetails?.status)}
                  </Typography>
                </div>
              </div>
            </div>

            <div style={{ ...passedStyles.columnFlex, flex: "1" }}>
              <p style={passedStyles.idLabel}>Amount</p>
              <p style={passedStyles.price}>
                {formattedAmount(milestoneDetails?.amount)}
              </p>
            </div>
          </div>
        </div>

        <div
          style={{
            ...passedStyles.overview_section,
            margin: "1vh 2vw 0 2vw",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "20px" : "50px",
            padding: isMobile && "1rem 1.6rem",
          }}
        >
          <div
            style={{ ...passedStyles.section_1, ...passedStyles.columnFlex }}
          >
            <div style={{ ...passedStyles.columnFlex }}>
              <div style={passedStyles.section_heading}>Description</div>
              <h3 style={passedStyles.section_sub_heading}>
                {milestoneDetails?.description}
              </h3>
            </div>
            <div style={{ ...passedStyles.columnFlex, marginTop: "2vh" }}>
              <BudgetCarousel
                details={milestoneDetails}
                isMobile={isMobile}
                passedStyles={passedStyles}
              />
            </div>
          </div>

          <div
            style={{
              ...passedStyles.section_2,
              ...passedStyles.columnFlex,
              gap: "20px",
            }}
          >
            <div style={passedStyles.section_heading}>Details</div>
            <div style={passedStyles.columnFlex}>
              <h3 style={passedStyles.section_sub_heading}>Contractor</h3>
              <div>
                <Box display="flex" alignItems="center">
                  {project?.Contractor && (
                    <Box
                      component="img"
                      src={
                        project?.Contractor?.profile_url ||
                        "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                      }
                      alt="Project Icon"
                      sx={{
                        width: 35,
                        height: 35,
                        borderRadius: "50%",
                        boxShadow: "0px 4px 2.67px 0px #00000026",
                        marginRight: 1,
                      }}
                    />
                  )}
                  {project?.Contractor?.company_name}
                </Box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MilestoneDetails;
